module.exports = __webpack_public_path__ + "static/media/stamp_16.4a6b5172.png";